import type { IExercise } from '../exercises';

export const PERSONAL_EPISODE_04_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-personal-04-01",
    "name": "热身",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["泡沫轴、Y字伸展、Y字推举、弹力带绕肩热身", "按视频示范控制节奏"],
    "sets": 1,
    "reps": "3分钟",
    "rpe": 3,
    "restSeconds": 0,
    "isBodyweight": true,
    "isWarmup": true,
    "source": "私教跟练 · 第4期",
    "targetMuscles": ["胸肩激活肌群"],
    "difficulty": "beginner",
    "demoStatus": "pending",
    "isStretch": false,
    "mediaIssue": "新文件实际为腿部热身，胸部热身素材待补齐",
  },
  {
    "id": "course-20261008-personal-04-02",
    "name": "双杠臂屈伸",
    "bodyPart": "chest",
    "equipment": "bodyweight",
    "subCategory": "lower-chest",
    "tips": ["身体前倾刺激下胸", "下放至大臂平行"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "demoUrl": "/media/collections-20261008/demos/reviewed-24ca815ed58130fac6c3a5da.mp4",
    "videoUrl": "/media/collections-20261008/videos/e4d0431f8354ab1acd97d110.mp4",
    "targetMuscles": ["下胸肌", "胸大肌"],
    "difficulty": "beginner",
    "source": "私教跟练 · 第4期",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-04-03",
    "name": "坐姿平推",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "mid-chest",
    "tips": ["挺胸沉肩肩胛后收", "推至胸口正上方"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "source": "私教跟练 · 第4期",
    "demoUrl": "/media/collections-20261008/demos/04016d904a2c1e56219eca83.mp4",
    "videoUrl": "/media/collections-20261008/videos/557f9191f93449eee09c1e16.mp4",
    "targetMuscles": ["胸大肌", "三角肌前束", "肱三头肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-04-04",
    "name": "上斜推胸",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "upper-chest",
    "tips": ["器械上斜推胸", "顶峰收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-3ee9bc71ea540df568db7e72.mp4",
    "videoUrl": "/media/collections-20261008/videos/5e075eb8e68cd60c0d0748af.mp4",
    "targetMuscles": ["上胸肌", "胸大肌", "三角肌前束", "肱三头肌"],
    "difficulty": "beginner",
    "source": "私教跟练 · 第4期",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-04-05",
    "name": "绳索夹上胸",
    "bodyPart": "chest",
    "equipment": "cable",
    "subCategory": "upper-chest",
    "tips": ["由下往上夹胸", "顶峰收缩停顿1秒"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教跟练 · 第4期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-7f9b1a015a2d297d4dd15e60.mp4",
    "videoUrl": "/media/collections-20261008/videos/b2db9271315c619358bdbff4.mp4",
    "targetMuscles": ["上胸肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-04-06",
    "name": "肩部训练",
    "bodyPart": "shoulders",
    "equipment": "cable",
    "subCategory": "front-deltoid",
    "tips": ["坐姿双绳索前平举", "按教学保持躯干稳定并控制抬举范围"],
    "sets": 3,
    "reps": "12",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教跟练 · 第4期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-9f5510b00c44fb5f07ef2a2b.mp4",
    "videoUrl": "/media/collections-20261008/videos/80c551bd1b3ac3dbb80c4db9.mp4",
    "targetMuscles": ["三角肌前束"],
    "difficulty": "intermediate",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
];
